module.exports = __webpack_public_path__ + "static/fonts/UnidreamLED.12fc160.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/comment/font/UnidreamLED.ttf
// module id = Mm5k
// module chunks = 133